import React from 'react'
import { BrowserMultiFormatReader } from '@zxing/library'
import Webcam from 'react-webcam'


export default class BarcodeScannerComponent extends React.Component {
  webcamRef = null
  
  componentDidMount() {
    this.setupTorch();
    this.startInterval();
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.stopStream) {
      let stream = this.getStream()
      if (stream) {
        stream.getTracks().forEach((track) => {
          stream.removeTrack(track)
          track.stop()
        })
        stream = null
      }
    }
  }
  
  setupTorch = () => {
    const { torch, onUpdate } = this.props
    // Turn on the flashlight if prop is defined and device has the capability
    if (
      typeof torch === 'boolean' &&
      // @ts-ignore
      this.supportsTorch()
    ) {
      const stream = this.getStream()
      if (! stream) {
        return
      }
      const track = stream.getVideoTracks()[0] // get the active track of the stream
      if (
        track &&
        track.getCapabilities().torch &&
        ! track.getConstraints().torch
      ) {
        track
          .applyConstraints({
            advanced: [{ torch }],
          })
          .catch((err) => onUpdate(err))
      }
    }
  }
  
  getStream() {
    if (this.webcamRef) {
      return this.webcamRef.video.srcObject
    }
    
    return null
  }
  
  supportsTorch() {
    if (navigator && navigator.mediaDevices) {
      return navigator.mediaDevices.getSupportedConstraints().torch
    }
    
    return null
  }
  
  interval = null
  startInterval = () => {
    const { delay } = this.props
    
    this.interval = setInterval(() => this.capture(), delay || 500)
  }
  
  capture = () => {
    const { onUpdate } = this.props
    const codeReader = new BrowserMultiFormatReader()
    const imageSrc = this.getImageSrc()
    if (imageSrc) {
      codeReader
        .decodeFromImage(undefined, imageSrc)
        .then((result) => onUpdate(null, result))
        .catch((err) => onUpdate(err))
    }
  }
  
  getImageSrc() {
    if (this.webcamRef) {
      return this.webcamRef.getScreenshot()
    }
    
    return null
  }
  
  render() {
    const { width, height, facingMode, videoConstraints } = this.props
    const { onError } = this.props
    
    return (
      <Webcam
        width={width || '110%'}
        height={height || '100%'}
        ref={ref => this.webcamRef = ref}
        style={{marginLeft: -20}}
        screenshotFormat="image/jpeg"
        videoConstraints={
          videoConstraints || {
            facingMode: facingMode || 'environment',
          }
        }
        audio={false}
        onUserMediaError={onError}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/complex/scanner/lib.js